import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import SweetAlert from "react-bootstrap-sweetalert";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import NumberFormat from "react-number-format";
import InputMask from "react-input-mask";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, FormGroup, Label, Alert } from "reactstrap";
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { allowedDepartments } from "../../helpers/currency_helper";
import { getScreenHeight } from "../../helpers/screen_height_helper";
// Actions
import {
  getBattlefield,
  getSpecBattlefield,
  // addBattlefield,
  // updateBattlefield,
  // deleteBattlefield,
  // updatePeriod,
} from "../../store/battlefield/actions";
// import { addTransfer, updateAgent } from '../../store/transfers/actions';
// import { addPriorityOrder } from '../../store/priority/actions';
import { onUpdateBattlefield } from "../../app-socket/events/battlefield";
import { onAddPriorityOrder } from "../../app-socket/events/priority";
import { onAddTransfer, onUpdateAgent } from "../../app-socket/events/transfer";
// Helpers
import { countryOptions } from "../../helpers/country_helper";
import { defaultDiacriticsRemovalMap } from "../../helpers/ascii_helper";

// Components
import BtnLoader from "../../components/Loaders/btnLoader";
import PageLoader from "../../components/Loaders/pageLoader";
import Breadcrumbs from "../../components/Breadcrumb";

// Images
import arrowRight from "../../assets/images/arrow_right.svg";
import arrowLeft from "../../assets/images/arrow_left.svg";
// Pages Components
import FilterComp from "./filter";
import ModalPriorityUK from "./modalPrUk";
import warehouse_uk from "../../assets/images/ukraine_flag.png";
import { Warehouse } from "lucide-react";

function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        {column.text} {sortElement}
      </div>
      {filterElement}
    </div>
  );
}
const highlightText = (text, highlight) => {
  if (!highlight) return text;
  const regex = new RegExp(`(${highlight})`, "gi");
  // return text.toLowerCase() === highlight.toLowerCase() ? <mark style={{ backgroundColor: 'yellow' }}>{text}</mark> : text
  const parts = text.split(regex);
  return parts.map((part, i) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <span key={i} style={{ backgroundColor: "yellow" }}>
        {part}
      </span>
    ) : (
      part
    ),
  );
};
class BattlefieldList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      sizePerPage: 10,
      totalSize: 0,
      selectedRows: [],
      my_filtered_battles: [],
      filtered_battles: [],
      priority_order: [],
      loading: false,
      hideActions: false,
      progress: { step: "Completed", time: 100 },
      modalPriorityOrder: false,
      modalPriorityUk: false,
      transferAgentFields: false,
      paymentDate: "",
      packingDate: "",
      sendDate: "",
      searchText: "",
      correctDatePm: true,
      correctDatePack: true,
      correctDateSend: true,
      alert: null,
      BattleFieldListColumns: [
        {
          text: "ID",
          dataField: "_id",
          sort: true,
          csvExport: false,
          editable: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1,
          footer: "",
        },
        {
          text: "Date",
          dataField: "date",
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.date !== null && new Date(row.date).toLocaleDateString("en-GB"),
          formatter: (cellContent, battle) => <h5 className="font-size-16 mb-1">{battle.date !== null && new Date(battle.date).toLocaleDateString("en-GB")}</h5>,
          footer: "",
        },
        {
          text: "Month",
          dataField: "month",
          sort: true,
          csvExport: true,
          hidden: true,
          editable: false,
          // csvFormatter: (cell, row, rowIndex) => row.date !== null && new Date(row.date).toLocaleDateString('en-GB'),
          formatter: (cellContent, battle) => <h5 className="font-size-16 mb-1">{battle.month}</h5>,
          footer: "",
        },
        {
          text: "Manager",
          dataField: "manager.workEmail",
          csvExport: true,
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.manager.length !== 0 && row.manager.fname + " " + row.manager.sname,
          formatter: (cellContent, battle) => (
            <div className="slname-width">
              {/* <h5 className='font-size-16 mb-1'>
                <span>
                  {' '}
                  {battle.manager.fname} &nbsp; {battle.manager.sname}{' '}
                </span>
              </h5> */}
              <h5 className="font-size-16 mb-1">
                <span>
                  <div>
                    {!battle.manager.profilePic ? (
                      <div className="avatar-sm m-2 d-inline-block">
                        <span className="avatar-title rounded-circle">{battle.manager.fname.charAt(0)}</span>
                      </div>
                    ) : (
                      <img className="rounded-circle avatar-sm m-2" src={battle.manager.profilePic} alt="profile pic" />
                    )}
                    <span>
                      {highlightText(battle.manager.fname, this.state.searchText)}
                      &nbsp;
                      {highlightText(battle.manager.sname, this.state.searchText)}
                    </span>
                  </div>
                </span>
              </h5>
            </div>
          ),
          footer: "",
        },
        {
          text: "Sender",
          dataField: "sender",
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, battle) => (
            <div className="name-width">
              <h5 className="font-size-16 mb-1 text-lowercase">{battle.sender && highlightText(this.removeDiacritics(battle.sender), this.state.searchText)}</h5>
            </div>
          ),
          footer: "",
        },
        {
          text: "Client's Name",
          dataField: "clientName",
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, battle) => (
            <div className="name-width">
              <h5 className={battle.newClient === true ? "font-size-16 mb-1 new-client-color" : "font-size-16 mb-1"}>{highlightText(battle.clientName, this.state.searchText)}</h5>
            </div>
          ),
          footer: "",
        },
        {
          text: "Invoice №",
          dataField: "invoiceNo",
          sort: true,
          editable: false,
          csvText: "Invoice Number",
          formatter: (cellContent, battle) => <h5 className="font-size-16 mb-1">{highlightText(battle.invoiceNo, this.state.searchText)}</h5>,
          footer: "",
        },
        {
          text: "Country & City",
          dataField: "country",
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          filter: textFilter(),
          headerFormatter: priceFormatter,
          csvFormatter: (cell, row, rowIndex) => `${row.country && this.getCountryName(row)}`,
          formatter: (cellContent, battle) => (
            <div className="name-width">
              <h5 className="font-size-16 mb-1">{battle.country && this.getCountryName(battle)}</h5>
              <p className="text-muted mb-0">{battle.region}</p>
            </div>
          ),
          footer: "",
        },
        {
          text: "Amount Sent",
          dataField: "invoiceSum",
          sort: true,
          editable: false,
          footer: (columnData) => {
            const isLastPage = this.state.currentPage === Math.ceil(this.state.totalSize / this.state.sizePerPage);

            const dataSource = this.state.filtered_battles.length !== 0 ? this.state.filtered_battles : this.props.battles;

            const total = isLastPage ? dataSource.reduce((acc, item) => acc + parseFloat(item.invoiceSum || 0), 0) : columnData.reduce((acc, item) => acc + parseFloat(item || 0), 0);

            return (
              <div className="btn-success p-2 rounded-pill text-center">
                <span className="font-size-16 fw-bold">
                  <NumberFormat value={total.toFixed(2)} displayType="text" thousandSeparator={true} prefix="$" />
                </span>
              </div>
            );
          },
          // footer: (columnData) => (
          //   <div className='btn-success p-2 rounded-pill text-center'>
          //     <span className='font-size-16 fw-bold'>
          //       <NumberFormat value={columnData.reduce((acc, item) => acc + parseFloat(item), 0).toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />
          //     </span>
          //   </div>
          // ),
          formatter: (cellContent, battle) => (
            <h5 className="font-size-16 mb-1">
              <NumberFormat value={parseFloat(battle.invoiceSum).toFixed(2)} displayType="text" thousandSeparator={true} prefix="$" />
            </h5>
          ),
        },
        {
          text: "Payment Method",
          dataField: "paymentMethod",
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, battle) => (
            <div className="name-width">
              <h5 className="font-size-16 mb-1">{highlightText(battle.paymentMethod, this.state.searchText)}</h5>
            </div>
          ),
          footer: "",
        },
        {
          text: "Order Status",
          dataField: "paymentStatus",
          sort: true,
          csvExport: false,
          editable: false,
          formatter: (cellContent, battle) => (
            <div
              className={
                battle.paymentStatus.toLowerCase() === "paid and sent"
                  ? "btn-success p-2 rounded-pill text-center"
                  : battle.paymentStatus.toLowerCase() === "not paid - sent"
                    ? "btn-warning p-2 rounded-pill text-center"
                    : null
              }
            >
              {battle.paymentStatus.toLowerCase() === "paid and sent" && <i className="bx bx-check-double font-size-16 align-middle me-2"></i>}
              {battle.paymentStatus.toLowerCase() === "not paid - sent" && <i className="bx bx-send font-size-16 align-middle me-2"></i>}
              <span className={battle.paymentStatus.toLowerCase() === "paid and sent" || battle.paymentStatus.toLowerCase() === "not paid - sent" ? "font-size-16 fw-bold" : "font-size-16"}>
                {highlightText(battle.paymentStatus, this.state.searchText)}
              </span>
            </div>
          ),
          footer: "",
        },
        {
          text: "Commentary",
          dataField: "comments",
          sort: true,
          csvExport: true,
          hidden: false,
          formatter: (cellContent, battle) => (
            <div className="name-width">
              <h5 className="font-size-16 mb-1">{highlightText(battle.comments, this.state.searchText)}</h5>
            </div>
          ),
          footer: "",
        },
        {
          text: "Source",
          dataField: "source",
          sort: true,
          hidden: false,
          csvExport: true,
          editable: false,
          formatter: (cellContent, battle) => <h5 className="font-size-16 mb-1">{highlightText(battle.source, this.state.searchText)}</h5>,
          footer: "",
        },
        {
          text: "Amount Received",
          dataField: "amountReceived",
          sort: true,
          csvExport: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) =>
            `${
              row.currAmountReceived === "₩"
                ? "KRW"
                : row.currAmountReceived === "$"
                  ? "USD"
                  : row.currAmountReceived === "€"
                    ? "EUR"
                    : row.currAmountReceived === "AU$"
                      ? "AUD"
                      : row.currAmountReceived === "£" && "GBP"
            } ${row.amountReceived}`,
          formatter: (cellContent, battle) => (
            <h5 className="font-size-16 mb-1">
              <NumberFormat value={battle.amountReceived} displayType="text" thousandSeparator={true} prefix={battle.currAmountReceived} />
            </h5>
          ),
          footer: "",
        },
        {
          text: "Payment Status",
          dataField: "orderStatus",
          sort: true,
          csvExport: true,
          editable: false,
          csvFormatter: (cellContent, battle) => {
            return cellContent === true ? "Received" : "";
          },
          formatter: (cellContent, battle) => (
            <>
              {battle.orderStatus && (
                <div className="d-flex gap-3">
                  <h5 className={this.props.profileData.department.depName === "Business Management Team" ? "font-size-16 pt-1" : "font-size-16"}>Received</h5>
                  {this.props.profileData.department.depName === "Business Management Team" && (
                    <Link className="text-warning" to="#">
                      <i className="mdi mdi-broom font-size-18" id="edittooltip" title="Cancel Status Received" onClick={() => this.cancelReceivedStatus(battle)}></i>
                    </Link>
                  )}
                </div>
              )}
              {this.props.profileData.department.depName === "Business Management Team" && (
                <>
                  {!battle.orderStatus && (battle.notificationSent === undefined || battle.notificationSent === false) && (
                    <Link className="text-primary" to="#">
                      <i className="fas fa-bell font-size-16" id="edittooltip" onClick={() => this.sendNotification(battle)}></i>
                    </Link>
                  )}
                </>
              )}
            </>
          ),
          footer: "",
        },
        {
          text: "Receive Date",
          dataField: "receivedDate",
          sort: true,
          csvExport: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.receivedDate !== null && new Date(row.receivedDate).toLocaleDateString("en-GB"),
          formatter: (cellContent, battle) => <h5 className="font-size-16 mb-1">{battle.receivedDate && new Date(battle.receivedDate).toLocaleDateString("en-GB")}</h5>,
          footer: "",
        },
        {
          dataField: "menu",
          isDummyField: true,
          csvExport: false,
          text: "Action",
          editable: false,
          formatter: (cellContent, battle) => (
            <div className="d-flex gap-3">
              {/* Conditionally hidden group */}
              {!this.state.hideActions && (
                <>
                  <Link className="text-info" to="#">
                    <i className="mdi mdi-content-copy font-size-18" id="edittooltip" onClick={() => this.handleCopyOrderClick(battle)}></i>
                  </Link>

                  {this.props.profileData.department.depName !== "Cosmetic Brand-Suppuru" && (
                    <Link className="text-primary" to="#">
                      <svg
                        id="Ukraine"
                        style={{ enableBackground: "new 0 0 300 300" }}
                        version="1.1"
                        viewBox="0 0 300 300"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="25"
                        height="25"
                        onClick={() => this.handleSendToPriorityUkClick(battle)}
                      >
                        <g>
                          <polygon
                            points="271.88,80 36,80 36.169,152 272,152"
                            style={{
                              fill: "#288EEA",
                              stroke: "#000000",
                              strokeWidth: 8,
                              strokeLinecap: "round",
                              strokeLinejoin: "round",
                              strokeMiterlimit: 10,
                            }}
                          />
                          <polygon
                            points="36.021,152 36.199,228 271.979,228 271.852,152"
                            style={{
                              fill: "#FEDA38",
                              stroke: "#000000",
                              strokeWidth: 8,
                              strokeLinecap: "round",
                              strokeLinejoin: "round",
                              strokeMiterlimit: 10,
                            }}
                          />
                        </g>
                      </svg>
                    </Link>
                  )}

                  <Link className="text-success" to="#">
                    <i className="mdi mdi-pencil font-size-18" id="edittooltip" onClick={() => this.handleEditOrderClick(battle)}></i>
                  </Link>

                  {this.props.profileData.permissions.includes("battlefieldBtnReceivedAccess") && (
                    <Link className="text-warning" to="#">
                      <i className="mdi mdi-cash-multiple font-size-18" id="edittooltip" onClick={() => this.handleEditReceivedClick(battle)}></i>
                    </Link>
                  )}

                  <Link className="text-danger" to="#">
                    <i className="mdi mdi-delete font-size-18" id="deletetooltip" onClick={() => this.handleDeleteBattlefield(battle)}></i>
                  </Link>
                </>
              )}

              {/* Always shown icon */}
              <Link className="text-primary" to="#">
                <i className="fas fa-warehouse font-size-16" id="edittooltip" onClick={() => this.handleSendToPriorityClick(battle)}></i>
              </Link>
            </div>
          ),
          footer: "",
        },
      ],
    };
    this.handleChildStateChange = this.handleChildStateChange.bind(this);
    this.child = React.createRef();
    this.searchInputRef = React.createRef();
    this.removeDiacritics = this.removeDiacritics.bind(this);
    this.getCountryName = this.getCountryName.bind(this);
    this.indication = this.indication.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);

    this.handleSendToPriorityClick = this.handleSendToPriorityClick.bind(this);
    this.handleSendToPriorityUkClick = this.handleSendToPriorityUkClick.bind(this);
    this.togglePriorityOrderModal = this.togglePriorityOrderModal.bind(this);
    this.togglePriorityOrderUk = this.togglePriorityOrderUk.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.toggleTransferAgent = this.toggleTransferAgent.bind(this);
    this.handleValidPriorityOrderSubmit = this.handleValidPriorityOrderSubmit.bind(this);

    // functions for scrolling left and right inside table on  arrows hover
    this.scrollLeft = this.scrollLeft.bind(this);
    this.scrollRight = this.scrollRight.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);

    // Accounting
    this.sendNotification = this.sendNotification.bind(this);
    this.cancelReceivedStatus = this.cancelReceivedStatus.bind(this);
    this.cancelStatusAlert = this.cancelStatusAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);

    // function to handle global action
    this.handleGlobalActionSubmit = this.handleGlobalActionSubmit.bind(this);

    this.handleGetSpecificBattlefield = this.handleGetSpecificBattlefield.bind(this);
  }
  componentDidMount() {
    const { onGetBattlefield, profileData, loading } = this.props;
    const values = {
      _id: allowedDepartments.includes(profileData.department.depName) ? profileData._id : "all",
    };
    onGetBattlefield(values);
    this.setState({ loading: loading });
  }
  componentDidUpdate(prevProps, prevState, ss) {
    // if (this.props !== prevProps && document.getElementById('myOrders').checked === true) {
    //   const { battles, date, profileData } = this.props;
    //   let my_filtered_battles = [];
    //   battles.map((battle) => {
    //     if (battle.year === date.year && battle.month === date.month && battle.manager._id === profileData._id) {
    //       my_filtered_battles.push(battle);
    //     }
    //     return my_filtered_battles;
    //   });
    //   if (my_filtered_battles.length === 0) {
    //     my_filtered_battles.push({ manager: 'No Results Found' });
    //   }
    //   this.setState({ my_filtered_battles: my_filtered_battles });
    // }
    if (prevProps.filtered_battles !== this.props.filtered_battles) {
      this.setState({ filtered_battles: this.props.filtered_battles });
    }
    if (prevProps.my_battles !== this.props.my_battles) {
      this.setState({ my_filtered_battles: this.props.my_battles.filter((battle) => battle.manager._id === this.props.profileData._id) });
    }
    if (prevProps.loading !== this.props.loading) {
      this.setState({ loading: this.props.loading });
    }
    if (prevState.searchText !== this.state.searchText) {
      console.log("inside state uodate");
      getScreenHeight();
    }
    // if (prevState.loading !== this.state.loading) {
    //   this.setState({ loading: this.state.loading });
    // }
    // const { onGetBattlefield } = this.props;
    // if(this.props.battles !== prevProps.battles){
    //   onGetBattlefield();
    // }
  }
  handleHideActionsToggle = (hide) => {
    this.setState({ hideActions: hide });
  };
  handleChildStateChange = (option, newState) => {
    if (option === "my_filter") {
      // this.setState({ my_filtered_battles: newState });
    } else if (option === "filter") {
      this.setState({ filtered_battles: newState });
    } else if (option === "columns") {
      this.setState({ BattleFieldListColumns: newState });
    } else if (option === "selected") {
      this.setState({ selectedRows: [] });
    }
  };

  handleGetSpecificBattlefield = (filterValues) => {
    // this.setState({ loading: true, progress: {"step": "Completed","time": 100 } });
    this.props.onGetSpecificBattlefield(filterValues);
  };
  /**
   * function to scroll left with arrow
   */
  scrollLeft = () => {
    let x = this.state.x;
    const y = this.state.y;
    this.state.scrollToken = setInterval(function () {
      const scroll = document.querySelector(".react-bootstrap-table");
      scroll.scroll(x, scroll.scrollTop);
      x = x - 3;
      if (x <= 1) {
        document.getElementById("arrow_left").classList.add("hiddenArrow");
      }
      if (x <= scroll.clientWidth) {
        document.getElementById("arrow_right").classList.remove("hiddenArrow");
      }
    }, y);
  };
  /**
   * function to scroll right with arrow
   */
  scrollRight = () => {
    let x = this.state.x;
    const y = this.state.y;
    this.state.scrollToken = setInterval(function () {
      const scroll = document.querySelector(".react-bootstrap-table");
      const content = document.getElementById("tableScroll");
      const total = scroll.scrollLeft + scroll.clientWidth;
      scroll.scroll(x, scroll.scrollTop);
      x = x + 3;
      if (x > 1) {
        document.getElementById("arrow_left").classList.remove("hiddenArrow");
      }
      if (total + 1 >= content.clientWidth) {
        document.getElementById("arrow_right").classList.add("hiddenArrow");
      }
    }, y);
  };
  /**
   * stop scrolling on mouse leave
   */
  mouseLeave = () => {
    let x = document.querySelector(".react-bootstrap-table").scrollLeft;
    this.setState({ x: x });
    clearInterval(this.state.scrollToken);
  };
  /**
   * Display empty table
   * @returns
   */
  indication = () => {
    let emptyMessage = "";
    // if (this.state.my_filtered_battles.length !== 0 && this.state.my_filtered_battles[0]['manager'] === 'No Results Found') {
    //   emptyMessage = `No Results Found`;
    // } else
    if (this.state.filtered_battles.length !== 0 && this.state.filtered_battles[0]["manager"] === "No Results Found") {
      emptyMessage = `No Results Found`;
    }
    return emptyMessage;
  };
  /**
   * @param {String} str
   * @returns cleared from any unnecassry characters and fonts string
   */
  removeDiacritics = (str) => {
    let changes = "";
    if (!changes) {
      changes = defaultDiacriticsRemovalMap;
    }
    for (var i = 0; i < changes.length; i++) {
      str = str.replace(changes[i].letters, changes[i].base);
    }
    return str;
  };
  /**
   * @param {String} oldValue
   * @param {String} newValue
   * @param {Arr} row
   * @param {String} column
   * @param {String} rowId
   * @returns saving data after editing is finsihed
   */
  afterSaveCell = (oldValue, newValue, row, column, rowId) => {
    const { /*onUpdateBattlefield*/ dispatch } = this.props;
    setTimeout(() => {
      row[column.dataField] = newValue;
      const updatedBattle = {
        _id: row._id,
        comments: newValue,
      };
      // onUpdateBattlefield(updatedBattle);
      onUpdateBattlefield({ dispatch, order: updatedBattle });
      // if (newValue !== oldValue) {
      const result = this.state.BattleFieldListColumns.map((row_map) => {
        if (row_map.id === rowId) {
          const newRow = { ...row_map };
          newRow[column.dataField] = newValue;
          return newRow;
        }
        return row_map;
      });
      this.setState({ BattleFieldListColumns: result });
      // }
    }, 100);
    return { newValue, async: true };
  };
  /**
   * @param {array} battle
   * @returns name of the country based on its value
   */
  getCountryName = (battle) => countryOptions.find((o) => o.value === battle.country).text;
  handleEditOrderClick = (battle) => this.child.current.handleEditOrderClick(battle);
  handleEditReceivedClick = (battle) => this.child.current.handleEditReceivedClick(battle);
  handleCopyOrderClick = (battle) => this.child.current.handleCopyOrderClick(battle);
  handleDeleteBattlefield = (battle) => this.child.current.handleDeleteBattlefield(battle);
  /**
   * Function to assign values of selected order to battle
   * @param {array} battle
   */
  handleSendToPriorityClick = (battle) => {
    this.setState({
      priority_order: {
        invoiceNo: battle.invoiceNo,
        clientName: battle.clientName,
        manager: battle.manager,
        whManager: null,
        logisticCom: "",
        delService: "",
        toxins: false,
        threads: false,
        managerCom: "",
        pckStarted: false,
        pckCompleted: false,
        docsReady: false,
        bookedPickup: false,
        readyToShip: false,
        importantOrder: false,
        onHold: false,
        paymentDate: battle.date,
        notificationSent: battle.notificationSent,
      },
      paymentDate: new Date(battle.date).toLocaleDateString("en-GB"),
    });
    this.togglePriorityOrderModal();
  };

  handleSendToPriorityUkClick = (battle) => {
    this.setState({
      priority_Uk: {
        invoiceNo: battle.invoiceNo,
        clientName: battle.clientName,
        manager: battle.manager,
        date: new Date(battle.date).toLocaleDateString("en-GB"),
      },
    });
    this.togglePriorityOrderUk();
  };
  /**
   * Set new order modal to open or close
   */
  togglePriorityOrderModal = () => this.setState((prevState) => ({ modalPriorityOrder: !prevState.modalPriorityOrder, transferAgentFields: false }));
  togglePriorityOrderUk = () => this.setState((prevState) => ({ modalPriorityUk: !prevState.modalPriorityUk, transferAgentFields: false }));
  /**
   * Function to handle date input
   * @param {*} event
   */
  onChangeDate = (event) => {
    if (parseFloat(event.target.value.substring(3, 5)) > 12) {
      if (event.target.name === "paymentDate") this.setState({ correctDatePm: false });
      if (event.target.name === "packingDate") this.setState({ correctDatePack: false });
      if (event.target.name === "sendDate") this.setState({ correctDateSend: false });
    } else {
      if (event.target.name === "paymentDate") this.setState({ correctDatePm: true, [event.target.name]: event.target.value });
      if (event.target.name === "packingDate") this.setState({ correctDatePack: true, [event.target.name]: event.target.value, sendDate: event.target.value, checkDateChange: event.target.value });
      if (event.target.name === "sendDate") this.setState({ correctDateSend: true, [event.target.name]: event.target.value });
    }
  };
  /**
   * Show/hide transfer agent fields
   */
  toggleTransferAgent = () => this.setState((prevState) => ({ transferAgentFields: !prevState.transferAgentFields }));
  /**
   * Function to submit new order or edit current order
   * @param {*} e
   * @param {array} values
   */
  handleValidPriorityOrderSubmit = (e, values) => {
    const {
      // onAddPriorityOrder,
      // onAddTransfer,
      // onUpdateAgent,
      dispatch,
      tr_agents,
      profileData,
    } = this.props;
    const { paymentDate, packingDate, sendDate } = this.state;
    const newPriorityOrder = {
      managerCreated: profileData.fname + " " + profileData.sname,
      paymentDate: paymentDate.split("/").reverse().join("-"),
      invoiceNo: values["invoiceNo"],
      client_info: { clientName: values["clientName"] },
      client_name: values["clientName"],
      manager: values["manager"].split("|")[0],
      whManager: null,
      packingDate: packingDate,
      sendDate: sendDate,
      delService: values["delService"],
      threads: values["threads"],
      managerCom: values["managerCom"],
      importantOrder: values["importantOrder"] ? values["importantOrder"] : false,
      pckStarted: false,
      // pckCompleted: false,
      docsReady: values["docsReady"],
      bookedPickup: false,
      readyToShip: false,
      logisticCom: "",
      hidden: false,
      onHold: false,
      toxThrPackaged: false,
      shouldSendNotification: values["shouldSendNotification"],
      transferAgentSent: values["transferAgentSent"],
      bitrixID: values["manager"].split("|")[1],
      notificationSent: false,
      completedOrder: false,
    };
    if (values["transferAgentSent"]) {
      let lowestPayment = [];
      let lowestOrders = [];
      lowestPayment = [...new Map(tr_agents.map((v) => [v.mainName, v])).values()];
      lowestPayment.sort(function (a, b) {
        return a.paymentAmount - b.paymentAmount;
      });
      tr_agents.map((id) => {
        if (lowestPayment[0]["mainName"] == id.mainName && id.onVacation == false) {
          lowestOrders.push(id);
        }
      });
      lowestOrders.sort(function (a, b) {
        return a.orderAmount - b.orderAmount;
      });
      const newAgentFee = {
        _id: lowestOrders[0]["_id"],
        mainName: lowestOrders[0]["mainName"],
        paymentAmount: lowestOrders[0]["paymentAmount"] + 0,
        orderAmount: lowestOrders[0]["orderAmount"] + 1,
      };
      const newTransfer = {
        invoiceNo: values["invoiceNo"],
        manager: values["manager"].split("|")[0],
        clientName: values["clientName"],
        address: values["address"],
        agentPaid: false,
        agent: lowestOrders[0]["_id"],
        agentPaymentAmount: 0,
        completed: false,
        problem: false,
        workNeeded: false,
        currentlyWorking: false,
        workDone: false,
      };
      const combinedData = [newTransfer, newAgentFee];
      onAddTransfer({ dispatch, combinedData });
      // onAddTransfer(newTransfer);
      // onUpdateAgent(newAgentFee);
      // onAddTransfer({ dispatch, newTransfer });
      // onUpdateAgent({ dispatch, newAgentFee });
    }
    // onAddPriorityOrder(newPriorityOrder);
    onAddPriorityOrder({ dispatch, newOrder: newPriorityOrder });
    this.togglePriorityOrderModal();
  };

  /**
   * Function to send notification
   * @param {array} battle
   */
  sendNotification = (battle) => {
    const { /*onUpdateBattlefield,*/ dispatch, managers } = this.props;
    const updateBattleAccounting = {
      _id: battle._id,
      invoiceNo: battle.invoiceNo,
      sender: battle.sender,
      clientName: battle.clientName,
      bitrixID: "",
      man_fname: "",
      man_sname: "",
      invoiceSum: battle.invoiceSum,
      accountingSubmit: true,
      notificationSent: true,
    };
    managers.map((id) => {
      if (id._id === battle.manager._id) {
        updateBattleAccounting["bitrixID"] = id.bitrixID;
        updateBattleAccounting["man_fname"] = id.fname;
        updateBattleAccounting["man_sname"] = id.sname;
      }
    });
    // onUpdateBattlefield(updateBattleAccounting);
    onUpdateBattlefield({ dispatch, order: updateBattleAccounting });
  };
  /**
   * Function to display alert for cancelling status of order
   * @param {array} battle
   */
  cancelReceivedStatus = (battle) => {
    const getAlertCancel = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes, cancel it!"
        confirmBtnBsStyle="success"
        title="Are you sure?"
        onConfirm={() => this.cancelStatusAlert(battle)}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        This action will cancel <span className="fw-bold">Received</span> status for <span className="fw-bold"> #{battle.invoiceNo}</span> order
      </SweetAlert>
    );
    this.setState({ alert: getAlertCancel() });
  };
  /**
   * Function to cancel status of Received order
   * @param {array} battle
   */
  cancelStatusAlert = (battle) => {
    const { /*onUpdateBattlefield*/ dispatch } = this.props;
    const updateBattleCancel = {
      _id: battle._id,
      invoiceNo: battle.invoiceNo,
      amountReceived: "",
      orderStatus: false,
      notificationSent: false,
      receivedDate: null,
      cancelReceived: true,
    };
    // onUpdateBattlefield(updateBattleCancel);
    onUpdateBattlefield({ dispatch, order: updateBattleCancel });
    this.hideAlert();
  };
  /**
   * @returns set state of alert to null
   */
  hideAlert = () => this.setState({ alert: null });
  /**
   * Handle actions for multiple rows
   * @param {*} e
   * @param {*} values
   */
  handleGlobalActionSubmit = (e, values) => {
    const { /*onUpdateBattlefield, onAddPriorityOrder,*/ dispatch, battles } = this.props;
    const { selectedRows } = this.state;
    let setPaidSentArr = [];
    if (values.action === "set") {
      this.setState({ battles: "" });
      selectedRows.map((id) => {
        setPaidSentArr.push({
          _id: id,
          paymentStatus: "Paid and Sent",
        });
      });
      // onUpdateBattlefield(setPaidSentArr);
      onUpdateBattlefield({ dispatch, order: setPaidSentArr });
      this.setState({ selectedRows: [] });
    } else if (values.action === "del") {
      this.setState({ battles: "" });
      const getAlert = () => (
        <SweetAlert
          danger
          showCancel
          confirmBtnText="Yes, delete it!"
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={() => this.child.current.deleteOrderAlert(selectedRows)}
          onCancel={this.hideAlert}
          focusCancelBtn
        >
          This action will delete selected orders from the table!
        </SweetAlert>
      );
      this.setState({ alert: getAlert() });
    } else if (values.action === "priority") {
      this.setState({ battles: "" });
      let priorityOrderArr = [];
      // this.togglePriorityOrderModal()
      battles.map((id, index) => {
        selectedRows.map((selRow) => {
          if (id._id === selRow) {
            this.setState({
              modalPriorityOrder: true,
              priority_order: {
                invoiceNo: id.invoiceNo,
                manager: id.manager,
                whManager: "",
                logisticCom: "",
                delService: "",
                toxins: false,
                threads: false,
                managerCom: "",
                pckStarted: false,
                pckCompleted: false,
                docsReady: false,
                bookedPickup: false,
                readyToShip: false,
                importantOrder: false,
                onHold: false,
                paymentDate: id.date,
                sendDate: "",
              },
            });
          }
        });
      });
    }
  };
  afterSearch = (newResult) => {
    const currentSearchValue = this.searchInputRef?.current?.input?.value || "";
    this.setState({ searchText: currentSearchValue });
  };
  render() {
    const { battles, managers, profileData, wh_managers_uk } = this.props;
    const {
      BattleFieldListColumns,
      selectedRows,
      my_filtered_battles,
      filtered_battles,
      alert,
      priority_order,
      paymentDate,
      correctDatePm,
      packingDate,
      correctDatePack,
      sendDate,
      correctDateSend,
      modalPriorityOrder,
      transferAgentFields,
      modalPriorityUk,
      priority_Uk,
      loading,
      hideActions,
      progress,
      searchText,
    } = this.state;
    const pageOptions = {
      sizePerPage:
        filtered_battles.length !== 0 && filtered_battles[0]["manager"] === "No Results Found"
          ? 0
          : filtered_battles.length !== 0 && filtered_battles.length < 1000 && profileData.department.depName !== "Business Management Team"
            ? filtered_battles.length
            : filtered_battles.length > 1000 && profileData.department.depName !== "Business Management Team"
              ? 10000
              : filtered_battles.length !== 0 && profileData.department.depName !== "Business Management Team"
                ? 100
                : my_filtered_battles.length !== 0 && my_filtered_battles[0]["manager"] === "No Results Found"
                  ? 0
                  : my_filtered_battles.length !== 0
                    ? my_filtered_battles.length
                    : profileData.department.depName === "Business Management Team"
                      ? 100
                      : battles.length,
      sizePerPageList: profileData.department.depName === "Business Management Team" ? [100, 300, 500] : [10000, 15000, 20000],
      totalSize:
        filtered_battles.length !== 0 && filtered_battles[0]["manager"] === "No Results Found"
          ? 0
          : filtered_battles.length !== 0
            ? filtered_battles.length
            : my_filtered_battles.length !== 0 && my_filtered_battles[0]["manager"] === "No Results Found"
              ? 0
              : my_filtered_battles.length !== 0
                ? my_filtered_battles.length
                : battles.length,
      custom: true,
      onPageChange: (page, sizePerPage) => {
        this.setState({
          currentPage: page,
          sizePerPage: sizePerPage,
          totalSize:
            filtered_battles.length !== 0 && filtered_battles[0]["manager"] === "No Results Found"
              ? 0
              : filtered_battles.length !== 0
                ? filtered_battles.length
                : my_filtered_battles.length !== 0 && my_filtered_battles[0]["manager"] === "No Results Found"
                  ? 0
                  : my_filtered_battles.length !== 0
                    ? my_filtered_battles.length
                    : battles.length,
        });
      },
    };
    const defaultSorted = [
      {
        dataField: "date", // if dataField is not match to any column you defined, it will be ignored.
        order: "asc", // desc or asc
      },
    ];
    const selectRow = {
      mode: "checkbox",
      selected: selectedRows,
      onSelectAll: (isSelect, rows, e) => {
        if (!isSelect) {
          let selectedRows = [];
          this.setState({ selectedRows: selectedRows });
        } else {
          rows.map((row, i) => {
            selectedRows.push(row._id);
            this.setState({ selectedRows: selectedRows });
          });
        }
      },
      onSelect: (row, isSelect, rowIndex, e) => {
        if (!isSelect) {
          let selected = selectedRows;
          selected = selectedRows.filter(function (el) {
            return el !== row._id;
          });
          this.setState({ selectedRows: selected });
        } else {
          selectedRows.push(row._id);
          this.setState({ selectedRows: selectedRows });
        }
      },
    };

    return (
      <React.Fragment>
        {/* <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/> */}
        {loading && <PageLoader progress={progress} isLoading={loading} />}
        <div className="page-content">
          <MetaTags>
            <title>Battlefield</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes("battlefieldAccess") ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title="Korupharma" breadcrumbItem="Battlefield" pg="btl" />
                <Row id="card-section" onLoad={getScreenHeight()}>
                  <Col lg="12">
                    <Card>
                      <CardBody className="cardBodySticky">
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="_id"
                          columns={BattleFieldListColumns}
                          data={
                            filtered_battles.length !== 0 && filtered_battles[0]["manager"] === "No Results Found"
                              ? []
                              : filtered_battles.length !== 0
                                ? filtered_battles
                                : my_filtered_battles.length !== 0 && my_filtered_battles[0]["manager"] === "No Results Found"
                                  ? []
                                  : my_filtered_battles.length !== 0
                                    ? my_filtered_battles
                                    : battles
                          }
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="_id"
                              columns={BattleFieldListColumns}
                              data={
                                filtered_battles.length !== 0 && filtered_battles[0]["manager"] === "No Results Found"
                                  ? []
                                  : filtered_battles.length !== 0
                                    ? filtered_battles
                                    : my_filtered_battles.length !== 0 && my_filtered_battles[0]["manager"] === "No Results Found"
                                      ? []
                                      : my_filtered_battles.length !== 0
                                        ? my_filtered_battles
                                        : battles
                              }
                              search={{ afterSearch: this.afterSearch }}
                              columnToggle
                              exportCSV={{ fileName: "Battlefield.csv" }}
                            >
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <FilterComp
                                    onGetSpecificBattlefieldFilter={this.handleGetSpecificBattlefield}
                                    props={this.props}
                                    ref={this.child}
                                    searchInputRef={this.searchInputRef}
                                    toolkitprops={toolkitprops}
                                    BattleFieldListColumns={BattleFieldListColumns}
                                    countryOptions={countryOptions}
                                    filteredBattles={filtered_battles}
                                    myFilteredBattles={my_filtered_battles}
                                    onStateChange={this.handleChildStateChange}
                                    onHideActionsToggle={this.handleHideActionsToggle}
                                    hideAlert={this.hideAlert}
                                    dispatch={this.props.dispatch}
                                  />
                                  <div id="arrow_left" className="hiddenArrow">
                                    <img src={arrowLeft} height="100" width="100" onMouseOver={this.scrollLeft} onMouseLeave={this.mouseLeave} />
                                  </div>
                                  <div id="arrow_right">
                                    {" "}
                                    <img src={arrowRight} height="100" width="100" onMouseOver={this.scrollRight} onMouseLeave={this.mouseLeave} />
                                  </div>
                                  <Row id="table-section">
                                    <BootstrapTable
                                      key={this.state.searchText}
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      selectRow={selectRow}
                                      defaultSorted={defaultSorted}
                                      classes={"table align-middle table-nowrap"}
                                      headerClasses="header-class is-sticky-hdr"
                                      id="tableScroll"
                                      cellEdit={cellEditFactory({
                                        mode: "click",
                                        blurToSave: true,
                                        afterSaveCell: this.afterSaveCell,
                                      })}
                                      bordered={true}
                                      filter={filterFactory()}
                                      noDataIndication={this.indication}
                                      responsive
                                    />
                                    <Col className="inner-custom-pagination d-flex mt-1">
                                      <div className="d-inline custom-dropdown">
                                        <SizePerPageDropdownStandalone {...paginationProps} />
                                      </div>
                                      <div className="text-md-right ms-auto pagination pagination-rounded justify-content-end mb-2">
                                        <PaginationListStandalone {...paginationProps} />
                                      </div>
                                    </Col>
                                    <div className={selectedRows.length === 0 ? "action_row hidden" : "action_row"}>
                                      <AvForm onValidSubmit={this.handleGlobalActionSubmit}>
                                        <AvField type="select" name="action" className="form-select" value={this.state.action || ""}>
                                          <option value="SELECT ACTION">SELECT ACTION</option>
                                          <option value="set">Set to "Paid and Sent"</option>
                                          <option value="del">Delete</option>
                                        </AvField>
                                        <button className="btn btn-success save-user"> APPLY </button>
                                      </AvForm>
                                    </div>
                                    <Modal size="xl" isOpen={modalPriorityOrder} className={this.props.className} toggle={this.togglePriorityOrderModal}>
                                      <ModalHeader toggle={this.togglePriorityOrderModal} tag="h4">
                                        Send Order to Priority Table
                                      </ModalHeader>
                                      <ModalBody>
                                        <AvForm onValidSubmit={this.handleValidPriorityOrderSubmit}>
                                          <Row>
                                            <Col md={8}>
                                              <Row>
                                                <Col md={3}>
                                                  <FormGroup className="mb-3">
                                                    <Label>Payment Date</Label>
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={paymentDate}
                                                      name="paymentDate"
                                                      ref={(el) => {
                                                        this.autoFocusInput = el;
                                                      }}
                                                      id="paymentDate"
                                                      onChange={this.onChangeDate}
                                                      className={correctDatePm ? " form-control input-mask" : "form-control input-mask is-invalid"}
                                                    />
                                                    {!correctDatePm && <div className="invalid-feedback">Invalid Date. Please use dd/mm/yyyy format</div>}
                                                  </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="invoiceNo"
                                                      label="Inv №"
                                                      type="text"
                                                      errorMessage="Invalid Invoice №"
                                                      autoComplete="off"
                                                      validate={{
                                                        required: {
                                                          value: true,
                                                        },
                                                      }}
                                                      value={priority_order.invoiceNo || ""}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                  <FormGroup className="mb-3">
                                                    <AvField name="clientName" label="Client Name" type="text" autoComplete="off" value={priority_order.clientName || ""} />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      type="select"
                                                      name="manager"
                                                      id="manager"
                                                      className="form-select"
                                                      label="Manager"
                                                      errorMessage="Please select manager"
                                                      validate={{
                                                        required: {
                                                          value: true,
                                                        },
                                                      }}
                                                      onChange={this.onChangeSelectManager}
                                                      value={priority_order.manager ? priority_order.manager._id + "|" + priority_order.manager.bitrixID : profileData._id + "|" + profileData.bitrixID}
                                                    >
                                                      <option>Choose</option>
                                                      {managers.map((manager) => {
                                                        return (
                                                          <option key={manager._id} value={manager._id + "|" + manager.bitrixID}>
                                                            {manager.fname} {manager.sname}
                                                          </option>
                                                        );
                                                      })}
                                                    </AvField>
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={3}>
                                                  <FormGroup className="mb-3">
                                                    <Label>Packing Date</Label>
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={packingDate || ""}
                                                      name="packingDate"
                                                      onChange={this.onChangeDate}
                                                      className={correctDatePack ? " form-control input-mask" : "form-control input-mask is-invalid"}
                                                    />
                                                    {!correctDatePack && <div className="invalid-feedback">Invalid Date. Please use dd/mm/yyyy format</div>}
                                                  </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                  <FormGroup className="mb-3">
                                                    <Label>Shipping Date</Label>
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={sendDate || ""}
                                                      name="sendDate"
                                                      onChange={this.onChangeDate}
                                                      className={correctDateSend ? " form-control input-mask" : "form-control input-mask is-invalid"}
                                                    />
                                                    {!correctDateSend && <div className="invalid-feedback">Invalid Date. Please use dd/mm/yyyy format</div>}
                                                  </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                  <FormGroup className="mb-3">
                                                    <AvField name="delService" label="Delivery Service" autoComplete="off" list="dels" value={priority_order.delService || ""} />
                                                    <datalist id="dels">
                                                      <optgroup label="Bank">
                                                        <option>Pack</option>
                                                        <option>EMS</option>
                                                        <option>EMS MC</option>
                                                        <option>EMS MN</option>
                                                        <option>EMS Premium</option>
                                                        <option>FedEx</option>
                                                        <option>DHL</option>
                                                        <option>GLS</option>
                                                        <option>PGMC</option>
                                                        <option>Logistics</option>
                                                        <option>Korean Post</option>
                                                        <option>Quick</option>
                                                      </optgroup>
                                                    </datalist>
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={4}>
                                                  {(priority_order.notificationSent == false || !priority_order.length) && (
                                                    <FormGroup className="mb-3 font-size-14">
                                                      <AvField
                                                        name="shouldSendNotification"
                                                        type="checkbox"
                                                        label="Notify when package is done"
                                                        className="form-check-input"
                                                        value={priority_order.shouldSendNotification || ""}
                                                      />
                                                    </FormGroup>
                                                  )}
                                                </Col>
                                                <Col md={4}>
                                                  <Row>
                                                    <Col md={6}></Col>
                                                    <Col md={6}>
                                                      <FormGroup className="mb-3">
                                                        <AvField name="threads" type="checkbox" label="Threads" className="form-check-input" value={priority_order.threads || ""} />
                                                      </FormGroup>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField name="docsReady" type="checkbox" label="Docs Ready" className="form-check-input" value={priority_order.docsReady || ""} />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={12}>
                                                  <FormGroup className="mb-3 ">
                                                    <AvField
                                                      name="managerCom"
                                                      label="Item Status"
                                                      type="textarea"
                                                      className="font-size-20"
                                                      rows="6"
                                                      autoComplete="off"
                                                      value={priority_order.managerCom || ""}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={12}>
                                                  <FormGroup className="mb-3 font-size-14">
                                                    <AvField
                                                      name="transferAgentSent"
                                                      type="checkbox"
                                                      label="Send to Transfer Agent Table"
                                                      className="form-check-input"
                                                      onClick={this.toggleTransferAgent}
                                                      disabled={priority_order.transferAgentSent && true}
                                                      value={priority_order.transferAgentSent || ""}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              {transferAgentFields && (
                                                <Row>
                                                  <Col md={8}>
                                                    <FormGroup className="mb-3">
                                                      <AvField name="address" label="Address" autoComplete="off" type="textarea" value="" rows="6" />
                                                    </FormGroup>
                                                  </Col>
                                                </Row>
                                              )}
                                              <Row>
                                                <Col>
                                                  <div className="text-end">
                                                    {loading && <BtnLoader />}
                                                    <button className="btn btn-success save-user" id="submit-form" disabled={loading && true}>
                                                      Send Order
                                                    </button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col md={4} className="text-left">
                                              {/* <hr className='vertical_line' /> */}
                                              <h3 className="fw-bold">Fedex</h3>
                                              <hr className="horizontal_line" id="fedex" />
                                              <p>Collect ~16:00</p>

                                              <h3 className="fw-bold">DHL</h3>
                                              <hr className="horizontal_line" id="dhl" />
                                              <p>Collect ~16:00</p>

                                              <h3 className="fw-bold">EMS</h3>
                                              <hr className="horizontal_line" id="ems" />
                                              <p>Collect ~15:30</p>

                                              <h3 className="fw-bold">Docs </h3>
                                              <hr className="horizontal_line" id="kor_post" />
                                              <p>Before ~15:30</p>

                                              <p>Export Permit and COO request before 2pm </p>

                                              <h3 className="fw-bold">Korean post</h3>
                                              <hr className="horizontal_line" id="q_serv" />
                                              <p> ~next day before 12</p>
                                              <h3 className="fw-bold">Quick Service</h3>
                                              <hr className="horizontal_line" id="q_serv" />
                                              <p>On request</p>
                                            </Col>
                                          </Row>
                                        </AvForm>
                                      </ModalBody>
                                    </Modal>
                                    {modalPriorityUk === true && <ModalPriorityUK data={priority_Uk} wh_data={wh_managers_uk} isOpen={modalPriorityUk} toggle={this.togglePriorityOrderUk} />}
                                  </Row>
                                  {alert}
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color="danger"> You do not have access to this page. </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

BattlefieldList.propTypes = {
  battles: PropTypes.array,
  onGetBattlefield: PropTypes.func,
  onGetSpecificBattlefield: PropTypes.func,
};

const mapStateToProps = ({ battles }) => ({
  managers: battles.managers,
  battles: battles.battles,
  my_battles: battles.my_battles,
  filtered_battles: battles.filtered_battles,
  date: battles.date,
  years: battles.years,
  months: battles.months,
  tr_agents: battles.tr_agents,
  wh_managers_uk: battles.wh_managers_uk,
  loading: battles.loading,
});

const mapDispatchToProps = (dispatch) => ({
  onGetBattlefield: (id) => dispatch(getBattlefield(id)),
  onGetSpecificBattlefield: (id) => dispatch(getSpecBattlefield(id)),
  dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BattlefieldList));
